import FormContainer from "@app/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { MainContentContainer } from "@app/components/MainContainer";
import { MainContent } from "@app/components/MainContainer/MainContent";
import { MainDescription } from "@app/components/MainContainer/MainDescription";
import { MainHeader } from "@app/components/MainContainer/MainHeader";
import { MainTitle } from "@app/components/MainContainer/MainTitle";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { PaymentMangerSchema } from "@app/pages/billling/Admin/paymentManagerSchema";
import { useModal, Button } from "@shortsworks/ui";
import {
  useGetAccountPlatform,
  useUpdateAccountPlatform,
} from "@shortsworks/user-api";
import { useQueryClient } from "@tanstack/react-query";
import {useEffect, Suspense, useState, useMemo} from "react"

export const PaymentManager = () => {
  const { showModal } = useModal();
  const [isModified, setIsModified] = useState<boolean>(false);

  const queryClient = useQueryClient();
  const {
    data: accountPlatformData,
    queryKey: accountPlatformQueryKey,
    isSuccess: isSuccessGetAccountPlatform,
  } = useGetAccountPlatform();

  const updateAccountPlatform = useUpdateAccountPlatform({
    mutation: {
      onSuccess: () => {
        return queryClient.invalidateQueries({
          queryKey: accountPlatformQueryKey,
        });
      },
    },
  });

  const { form, parseForm, schemas, setFormValues, formValues } = useFormWithSchema<{email: string, name: string}>({
    formSchemas: PaymentMangerSchema,
    mode: "onChange",
  });

  // use effect 에서 return 이 cleanup 인 점 참고
  useEffect(() => {
    if (!isSuccessGetAccountPlatform) {
      return;
    }

    //@ts-ignore
    const { name, email } = accountPlatformData.data;
    setFormValues({
      name,
      email,
    });
  }, [isSuccessGetAccountPlatform]);


  // pareForm 이 필수 입력이 아니라는 에러가 발생됨
  // 매번 변경마다 체크하지 않고 memo
  const isFormDataSame: boolean = useMemo(() => {
    if (!isSuccessGetAccountPlatform) {
      return true;
    }

    // @ts-ignore
    const { name: previousName, email: previousEmail } = accountPlatformData.data;
    const { name, email } = formValues;

    return previousName === name && previousEmail === email;
    return true
  }, [formValues]);

  // 동일한 경우 변경되지 않도록 처리
  const changeAdminInfo = async () => {
    const form = parseForm();
    if (!form.success || !isSuccessGetAccountPlatform) return;

    const { apiKey, platformId } = accountPlatformData.data;
    // @ts-ignore
    const { name: previousName, email: previousEmail } = accountPlatformData.data;
    const { name, email } = form.data;

    if(previousName === name && previousEmail === email) {
      return showModal(CommonErrorModal, {title: "기존과 내용이 동일합니다."});
    }

    const result = await updateAccountPlatform.mutateAsync({
      data: {
        apiKey,
        platformId,
        platformName: name,
        email,
      },
    });

    if (!result.data.success) {
      return showModal(CommonErrorModal, {
        title: "결제 관리자 변경에 실패했습니다.",
      });
    }

    // 페이지 변경 시 기존 정보 가져오는 현상으로 인해 refetch
    return showModal(CommonErrorModal, {
      title: "변경 완료",
      description: "결제 관리자 정보가 변경되었습니다.",
    });
  };
  return (
    <MainContentContainer>
      <MainHeader>
        <MainTitle>결제 관리자</MainTitle>
        <MainDescription>
          결제 관련 안내나 청구서 등에 선택적으로 활용됩니다.
        </MainDescription>
      </MainHeader>
      <MainContent>
        <Suspense>
          <FormContainer className="w-1/2" schemas={schemas} form={form} />
          <div className="mt-2 text-sm text-blue-400">
            결제 정보를 받을 이메일을 지정해주세요. 비워두면 결제 관련 메일을
            받아볼 수 없어요.
          </div>
          {
              isFormDataSame &&
              <div className="text-gray-400 text-sm py-1">내용이 기존과 동일한 경우 변경할 수 없습니다.</div>
          }
          <Button disabled={isFormDataSame} className="mt-4" onClick={changeAdminInfo}>
            저장하기
          </Button>
        </Suspense>
      </MainContent>
    </MainContentContainer>
  );
};
